import React from "react";
import * as Api from "api/api";

import * as Form from 'tsui/Form';
import { ApiCard } from "api";
import { Box, FormControl, InputLabel, MenuItem, Radio, Select, SelectChangeEvent, Switch } from "@mui/material";
import { styled as muiStyled } from '@mui/system';
import { useTranslation } from "react-i18next";
import session_ from 'api/session';

const ImageComponent = muiStyled('img')({});


interface ReadMessagesDetailsProps {
    onClose: () => void;
    messageId: string;

}


const label = { inputProps: { 'aria-label': 'Switch demo' } };


export default function ReadMessages(props: ReadMessagesDetailsProps) {
    const form = Form.useInputForm();

    const [t] = useTranslation();

    const [swtichonOff, setSwtichonOff] = React.useState('off');
    const swtichonOffRef = React.useRef('off')


    const handleSwitchOnChange = (event: SelectChangeEvent) => {
        setSwtichonOff(event.target.value);
        swtichonOffRef.current = event.target.value;
        console.log('swtichonOffRef', swtichonOffRef.current)
    };

    const buttonRef = React.useRef<HTMLButtonElement>();

    const onSubmit = React.useCallback((evt: Form.InputFormEvent) => {

        evt.data.cardId = props.messageId
        console.log('evt.data.cardId', evt.data.cardId)

        Api.requestSessionJson<any>('messages', 'read', { messageId: props.messageId, isReadMessage: swtichonOffRef.current }, {}).then(d => {
            // console.log('ddddddddddddddd', JSON.stringify(d))

            // setHtmlPreview(JSON.stringify(d))

            props.onClose();

        }).catch(err => console.log(err));
        props.onClose();

    }, []);

    // console.log('template NAME Out of onSubmit', templateName)

    // TODO: remove in the future
    // return <></>

    return <Form.PageFormDialog title='Message Read' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>


        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <Select
                    value={swtichonOff}
                    onChange={handleSwitchOnChange}
                >
                    <MenuItem key='on' value='on'>{t('on')}</MenuItem>
                    <MenuItem key='off' value='off'>{t('off')}</MenuItem>
                </Select>
            </FormControl>
        </Box>


    </Form.PageFormDialog>


}
